import { useQuery } from '@tanstack/react-query';

import { APIKey, apiRoutes } from 'constants/apiKeys';
import baseFetcher from 'shared/helpers/baseFetcher';
import { EventSearchEntry } from 'events/helpers/SearchModal.utils';

export const MIN_SEARCH_LENGTH = 3;

export function useEventSearch(query: string) {
  const trimmed = query.trim();

  return useQuery<EventSearchEntry[]>({
    queryKey: [APIKey.EVENT, 'search', trimmed],
    queryFn: () =>
      baseFetcher(
        `${apiRoutes.events()}?search=${encodeURIComponent(trimmed)}`
      ),
    enabled: trimmed.length >= MIN_SEARCH_LENGTH,
  });
}
